// Legacy Colors - Use design tokens from tailwind.config.js instead
// These will be removed once migration is complete
// Colors designed in OKLCH for perceptual uniformity, converted to hex

export const Colors = {
  theme: '#111113',     // oklch(10% 0.004 270) - bg-surface-primary
  tabIconSelected: '#6366ca', // oklch(55% 0.14 270) - text-primary
  tabIconDefault: '#808084',  // oklch(55% 0.003 270) - text-tertiary
  backgroundDark: '#000000',  // oklch(0% 0 0) - bg-background-950
  backgroundLight: '#fafafa', // oklch(98% 0 0) - bg-white
  borderColorDark: '#16161a', // oklch(12% 0.005 270) - border-dark
  borderColorLight: '#cacacc', // oklch(80% 0.003 270) - border-light
  codeBox: '#1a1a1d',   // oklch(14% 0.004 270) - bg-surface-code
};

export default Colors;
